// Custom browser events for cross-component communication
const CUSTOM_EVENTS = {
  ROOM_BOOKMARK_CHANGED: "roomBookmarkChanged",
};

export default CUSTOM_EVENTS;
